import { FlowTypes } from 'v2/types'
import { logger } from 'v2/utils/logger'
import { useFlowStore } from '../store'

const validFlowTypes = new Set<string>(Object.values(FlowTypes))

/**
 * A hook that provides access to the start node type from URL params
 * This is useful for components that need to know the type of flow being worked on
 */
export const useStartNodeType = () => {
  const flowType = useFlowStore((state) => state.currentFlowType)
  if (flowType === 'omni') return flowType
  if (flowType && validFlowTypes.has(flowType)) return flowType as FlowTypes
  if (flowType) {
    logger.warn(
      `[useStartNodeType] Unexpected flowType: "${flowType}", falling back to incoming_call`,
    )
  }
  return FlowTypes.incoming_call
}
